import React, { useRef } from 'react';
import { Button } from 'primereact/button';
import { ConfirmPopup } from 'primereact/confirmpopup';
import config from '@/config';
import './styles.scss';
import { Toast } from 'primereact/toast';

const { API_URL } = config;

export const DeleteProducts = ({ visible, open, hide, productData, updateLoad }) => {
  const toast = useRef(null);
  const buttonEl = useRef(null);

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_URL}/products`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ _id: productData?._id }),
      });

      if (!response.ok || response.status !== 200) {
        throw new Error('Server error!');
      }

      toast.current.show({ severity: 'info', summary: 'Видалено', detail: 'Дані успішно видалено.', life: 3000 });
      updateLoad();
    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }
  };

  const accept = () => {
    handleDelete();
  };

  const reject = () => {
    toast.current.show({
      severity: 'warn',
      summary: 'Відміна',
      detail: 'Ви відмінили видалення данних.',
      life: 3000,
    });
  };
  return (
    <div>
      <Toast ref={toast} />
      <ConfirmPopup
        target={buttonEl.current}
        visible={visible}
        onHide={hide}
        message='Ви дійсно хочете видалити дані?'
        icon='pi pi-exclamation-triangle'
        accept={accept}
        reject={reject}
        acceptLabel='Так'
        rejectLabel='Ні'
      />
      <Button type='button' ref={buttonEl} icon='pi pi-trash' severity='warning' rounded onClick={open} />
    </div>
  );
};
